import * as React from "react";
import styled from "@emotion/styled";
import classNames from "classnames";
import { keyframes } from "@emotion/core";
import { useTheme } from "@/hooks/useTheme";
import BounceLoader from "react-spinners/BounceLoader";
import OverlayContext, { initOverlayStore } from "@/contexts/Overlay";

const fadeIn = keyframes`
  0% {
    visibility: hidden;
    opacity: 0;
  }
  1% {
    visibility: visible;
  }
  100% {
    opacity: 0.5;
  }
`;

const fadeOut = keyframes`
  0% {
    visibility: visible;
    opacity: 0.5;
  }
  100% {
    visibility: hidden;
    opacity: 0;
  }
`;

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  &.exiting {
    visibility: hidden;
    opacity: 0;
    animation: ${fadeOut} 0.3s linear 0s 1 forwards;
  }

  &.entered {
    visibility: visible;
    opacity: 0.5;
    animation: ${fadeIn} 0.3s linear 0s 1 forwards;
  }
`;

const Loading = () => {
  const { COLOR_THEME } = useTheme();
  const overlayContext = React.useContext(OverlayContext) || initOverlayStore(false);

  return (
    <Wrapper
      className={classNames({
        entered: overlayContext.isActive,
        exiting: !overlayContext.isActive,
      })}
    >
      <BounceLoader color={COLOR_THEME.extras?.primary || "#36D7B7"} size={100} />
    </Wrapper>
  );
};

export default Loading;
